import { Link } from "react-router-dom";
import { FiFacebook, FiInstagram, FiTwitter, FiYoutube, FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <h2><span className="logo-main">Style</span><span className="logo-accent">Hub</span></h2>
          <p>Your destination for premium South Asian & contemporary fashion. Crafted with love, delivered with care.</p>
           
        </div>
        <div className="footer-col">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/shop">Shop All</Link>
          <Link to="/shop?category=new">New Arrivals</Link>
          <Link to="/shop?category=sale">Sale</Link>
          <Link to="/about">About Us</Link>
        </div>
        
         
        <div className="footer-col">
          <h4>Contact</h4>
          <p><FiMapPin /> 180001, C-656/7, Sainik Colony</p>
          <p><FiPhone /> +92 8096554464</p>
          <p><FiMail /> rizzglam@gmail.com</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2025 Rizzglam.co.in. All rights reserved.</p>
        
      </div>
    </footer>
  );
}
